import { render } from "./PCVistaVolcarPartida.vue?vue&type=template&id=21e4c030&scoped=true"
import script from "./PCVistaVolcarPartida.vue?vue&type=script&lang=js"
export * from "./PCVistaVolcarPartida.vue?vue&type=script&lang=js"

import "./PCVistaVolcarPartida.vue?vue&type=style&index=0&id=21e4c030&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e4c030"]])

export default __exports__